import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import { toast } from "react-toastify";

function DeleteAction({ item, lockDays, lockDaysBoolean, onUpdate }: any) {
  const [loading, setLoading] = useState(false);


    const { fetchData: fetchUpdateSongData } = useFetch({
        url: `${import.meta.env.VITE_API_URL}/events/music/pending/${item.id}`,
        method: "PUT",
    });

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this song?")) return;

    setLoading(true);
    try {
        const response = await fetchUpdateSongData();
        
        const updatedSong = response.data;
        if (!updatedSong || updatedSong.status !== "pending") {
            throw new Error("Failed to reset song status");
        }
        if (onUpdate) {
            onUpdate(updatedSong);
        }

      toast.info("Song deleted successfully!");
    } catch (error) {
      console.error("Error deleting song:", error);
      alert("Failed to delete song. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className={lockDaysBoolean ? "disabled-action-container" : "" } style={{ position: "relative", display: "inline-block" }}>
    <DeleteOutlineIcon
      className={`music-icon remove ${lockDaysBoolean ? "disabled-action" : ""}`}
      onClick={ lockDaysBoolean ? undefined : handleDelete  }
      titleAccess={lockDaysBoolean ? "Remove" : "" }
      style={{
        cursor: lockDaysBoolean ? "not-allowed" : "pointer" ,
        opacity: loading ? 0.5 : (lockDaysBoolean ? 0.5 : 1),
        color: loading ? "#ccc" : "#d32f2f",
      }}
    />
    {lockDaysBoolean && (
      <span className="disabled-tooltip">
        Delete locked {lockDays} days before event
      </span>
    )}
  </div>
  );
}

export default DeleteAction;
